import React from 'react'
import PropTypes from 'prop-types'

import PrimaryFooter from './components/PrimaryFooter/PrimaryFooter'
import BrandFooter from './components/BrandFooter/BrandFooter'
import ServiceFooter from './components/ServiceFooter/ServiceFooter'
import CheckoutFooter from './components/CheckoutFooter/CheckoutFooter'
import SocialAppFooter from './components/SocialAppFooter/SocialAppFooter'
import LegalFooter from './components/LegalFooter/LegalFooter'

import * as Styled from './Footer.styles'

/* eslint-disable id-length */
const Footer = ({
  type,
  primaryHidden,
  brandHidden,
  serviceHidden,
  socialappHidden,
  legalHidden,
  creditHidden,
  'data-test': dataTest,
  onClick
}) => (
  <Styled.ArgosFooter type={type} data-test={dataTest}>
    {type === 'default' ? (
      <>
        {!primaryHidden && <PrimaryFooter />}
        {!brandHidden && <BrandFooter />}
        {!serviceHidden && <ServiceFooter />}
        {!socialappHidden && <SocialAppFooter />}
        {!legalHidden && <LegalFooter onClick={onClick} />}
      </>
    ) : (
      <>
        <CheckoutFooter creditHidden={creditHidden} />
        <LegalFooter variant={type} onClick={onClick} />
      </>
    )}
  </Styled.ArgosFooter>
)

Footer.propTypes = {
  /**
   * Either default of checkout footer
   */
  type: PropTypes.oneOf(['default', 'checkout']),
  /**
   * If primary section should not be rendered
   */
  primaryHidden: PropTypes.bool,
  /**
   * If brand section should not be rendered
   */
  brandHidden: PropTypes.bool,
  /**
   * If service section should not be rendered
   */
  serviceHidden: PropTypes.bool,
  /**
   * If socialapp section should not be rendered
   */
  socialappHidden: PropTypes.bool,
  /**
   * If legal section should not be rendered
   */
  legalHidden: PropTypes.bool,
  /**
   * If credit section should not be rendered
   */
  creditHidden: PropTypes.bool,
  /**
   * Specify an optional data-test attribute to be added to your Footer for e2e testing
   */
  'data-test': PropTypes.string,
  /**
   * Optional prop to pass through onClick events when legal footer links are clicked
   */
  onClick: PropTypes.func
}

Footer.defaultProps = {
  'data-test': 'component-footer',
  type: 'default',
  primaryHidden: false,
  brandHidden: false,
  serviceHidden: false,
  socialappHidden: false,
  legalHidden: false,
  creditHidden: false,
  onClick: () => {}
}

export default Footer
